export default __webpack_public_path__ + "static/media/Aqua_Drib1.d1e51b84.mp3";